<template>
    <ul class="nav">
        <li><router-link to="/coaches/coach-booking">Upcoming</router-link></li>
        <li><router-link to="/coaches/booking-completed">Completed</router-link></li>
        <li><router-link to="/coaches/booking-cancelled">Cancelled</router-link></li>
    </ul>
</template>